import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import TableHeader from './TableHeader';
import styles from './Table.module.css';
import { Icons } from '@/assets';
import { useCallback } from 'react';
import {
  handleCopyableIconClick,
  handleCopyableNameClick,
} from '@/utils/copyableFieldAction';

const CONTAINER_COPY_OPTIONS = { label: 'Container Number' };

const TableEx = ({
  data,
  columns,
  getRowStyle,
  checkBox,
  isLiveUnload,
  onClickeditSizeAndSsl,
  onClickeditSizeAndSslLoadContainers,
}) => {
  const [selectedData, setSelectedData] = useState([]);
  const getCellValue = (col, val, row) => {
    if (col.component) {
      return <col.component value={val} {...row} />;
    }
    return val;
  };

  const handleContainerNameClick = useCallback((e, rowData) => {
    handleCopyableNameClick(e, rowData.name, CONTAINER_COPY_OPTIONS);
  }, []);

  const handleContainerIconClick = useCallback((e, rowData) => {
    handleCopyableIconClick(
      e,
      rowData.name,
      rowData.trackingUrl,
      CONTAINER_COPY_OPTIONS
    );
  }, []);

  return (
    <div className={styles.tableContainer}>
      <table
        className={styles.table}
        // style={{ width: isLiveUnload ? '50%' : '100%' }}
      >
        <TableHeader columns={columns} />
        <tbody>
          {data?.map((row) => {
            const isDataSelected = selectedData.includes(row.id);
            return (
              <tr key={row.id} className={styles.tableRow}>
                {checkBox && (
                  <td className={styles.checkboxCell}>
                    <input
                      type="checkbox"
                      checked={isDataSelected}
                      onChange={() => {}}
                    />
                  </td>
                )}
                {columns?.map((col) => {
                  if (col.field === 'size' || col.field === 'ssl') {
                    return (
                      <td key={col.field} className={styles.tableCell}>
                        {isLiveUnload === true ? (
                          <div
                            onClick={
                              row.id
                                ? onClickeditSizeAndSslLoadContainers
                                : onClickeditSizeAndSsl
                            }
                            className={styles.cellContainer}>
                            {row[col.field]}
                            <ReactSVG
                              className={styles.penIcon}
                              src={Icons.pen}
                            />
                          </div>
                        ) : (
                          row[col.field]
                        )}
                      </td>
                    );
                  }
                  if (col.field === 'name') {
                    return (
                      <td key={col.field} className={styles.tableCell}>
                        <div className={'flex items-center justify-center'}>
                          <span
                            className="cursor-pointer hover:underline"
                            onClick={(e) => handleContainerNameClick(e, row)}>
                            {row[col.field]}
                          </span>
                          <span
                            className="cursor-pointer underline"
                            onClick={(e) => handleContainerIconClick(e, row)}>
                            <ReactSVG
                              src={Icons.externalLink}
                              className={styles.linkIcon}
                            />
                          </span>
                        </div>
                      </td>
                    );
                  }

                  return (
                    <td key={col.field} className={styles.tableCell}>
                      {getCellValue(col, row[col?.field], row) || '-'}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableEx;
